interface GetLocationOriginInterface {
    isStandalone: boolean;
    bootedAsChild: boolean;
    routerBasePath: string;
}

/**
 * function that is parsing location and returns origin based on config
 * @param GetLocationOriginInterface
 * @returns {string} with proper origin ( for legacy dash everything before #, for standalone just origin, for nested product in app origin + router base path)
 */

export const getLocationOrigin = ({
    isStandalone,
    bootedAsChild,
    routerBasePath = '',
}: GetLocationOriginInterface): string => {
    if (isStandalone) {
        return location.origin;
    }

    if (bootedAsChild) {
        return `${location.origin}${routerBasePath}`;
    }
    // as legacy dash is using hash router we need to get proper basepath for it, as not always it would be equal to location.origin
    const legacyUrl = location.hash && `${location.href?.split('#')?.[0]}#`;
    return legacyUrl || location.origin;
};
